import React, { useMemo } from 'react';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import './Footer.css';
import styled from 'styled-components';
import { isEmpty } from 'lodash';
import { NotificationBar, UpperFooter, LowerFooter } from './FooterComponents';
import useNews from '../../models/News';
import useCheckScrollToFooter from './hooks/useCheckScrollToFooter';

const MainContainer = styled.div`
  display: ${({ pathname }) => (pathname === '/customers/validate_credit_card' ? 'none' : 'block')};

  @media (max-width: 670px) {
    display: ${({ pathname }) => (pathname === '/car_parks/map' ? 'none' : 'block')};
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 1;
`;

function Footer({ isMaintenance }) {
  const history = useHistory();
  const { hash = '' } = useLocation();
  const { announcement } = useNews();
  const { isScrollToFooter, footerElement } = useCheckScrollToFooter();
  const replacedHash = hash.replace('#', '');

  const [manualShowBar, setManualShowBar] = React.useState(true);

  const showBar = useMemo(() => {
    if (isMaintenance || !manualShowBar) {
      return false;
    }

    return !isEmpty(announcement);
  }, [announcement, history?.location?.pathname, isMaintenance, manualShowBar]);

  const hideFooter =
    history?.location?.pathname.includes('our-company') && replacedHash === 'mobile';

  if (hideFooter) {
    return <></>;
  }

  return (
    <MainContainer id="main-footer" pathname={history?.location?.pathname}>
      <NotificationBar
        shownotification={showBar}
        announcement={announcement}
        isScrollToFooter={isScrollToFooter}
        setManualShowBar={setManualShowBar}
      />
      <Container id="footer" ref={footerElement}>
        {history?.location?.pathname.includes('/car_parks/detail') ||
        history?.location?.pathname.includes('/car_parks/map') ? null : (
          <UpperFooter />
        )}
        <LowerFooter />
      </Container>
    </MainContainer>
  );
}

export default withRouter(Footer);
